// file imports
import { EventDetailsSection, PresentationDetailsSection, StateMessage } from '@/components';
import { IEvent, IPresentation } from '@/types';

type PreEventTabProps = {
  event: IPresentation | IEvent | null;
  eventSlug?: string;
  loading: boolean;
  error?: string | null;
};

export default function PreEventTab({ event, loading, error }: PreEventTabProps) {
  if (loading) {
    return <StateMessage type="loading" loadingMessage="Loading event details..." notFoundMessage="Event not found" />;
  }

  if (error) {
    return <StateMessage type="error" loadingMessage="Loading event details..." errorMessage={`Error: ${error}`} notFoundMessage="Event not found" />;
  }

  if (!event) {
    return <StateMessage type="not-found" loadingMessage="Loading event details..." notFoundMessage="Event not found" />;
  }

  return (
    <>
      {event.eventType === 'Presentation' && <PresentationDetailsSection event={event as IPresentation} />}
      {event.eventType === 'Event' && <EventDetailsSection event={event as IEvent} />}
    </>
  );
}
